import { render, staticRenderFns } from "./alarms.vue?vue&type=template&id=6dca5e6a&"
import script from "./alarms.vue.js?vue&type=script&lang=js&"
export * from "./alarms.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports